import { useCallback } from 'react';
import { resolveNodeByLabel } from '../../lib/explanationRefs';
import { computeFocus, type TourStep } from '../../lib/tour';
import { useArchitectureStore } from '../../store/useArchitectureStore';
import TourPlayer from '../tour/TourPlayer';

/** The guided story of an architecture diagram: each step lights up the nodes it links to and the connectors between them. */
export default function TourOverlay() {
  const documentation = useArchitectureStore((s) => s.documentation);
  const nodes = useArchitectureStore((s) => s.diagram.nodes);
  const edges = useArchitectureStore((s) => s.diagram.edges);

  const focusFor = useCallback((step: TourStep) => computeFocus(step, nodes, edges), [nodes, edges]);
  const resolveReference = useCallback(
    (kind: string, target: string) => {
      const node = kind === 'node' ? resolveNodeByLabel(nodes, target) : undefined;
      return node ? [node.id] : null;
    },
    [nodes],
  );

  return (
    <TourPlayer
      documentation={documentation}
      focusFor={focusFor}
      focusKey={focusFor}
      resolveReference={resolveReference}
      emptyHint={
        <>
          Add numbered steps to its explanation, as headings that begin <code>### Step 1:</code>, with node links such as <code>[nginx](#node:nginx)</code> in each step.
        </>
      }
    />
  );
}
